module.exports = __webpack_public_path__ + "img/ZJ5212.14aaeb12.png";